import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';
import { Card, Empty, Select } from 'antd';

am4core.useTheme(am4themes_animated);

const transformFiledToLabel = (fieldName) => {
    return fieldName.replace('_', '/').replace('qty', 'ltr')
}

function FuelConsumptionRateChart({ data: docs, idleFuelRate, selectedGroup, assetData, standardFuelRate, processDataWithGroups,
    chartUnit = 'hours', loading, ...props }) {

    const [data, setData] = useState([]);
    const [rateTypeField, setRateTypeField] = useState('hours_qty');
    const [rateTypeFieldReverse, setRateTypeFieldReverse] = useState('qty_hours');

    const [header, setHeader] = useState('--');

    const [standardRateHour, setStandardRateHour] = useState(0);
    const [standardRateKm, setStandardRateKm] = useState(0);

    const [stdLabel, setStdLabel] = useState('')

    useEffect(() => {
        // console.log(selectedGroup);
        const group = processDataWithGroups(docs, selectedGroup)
        // console.log(group);
        setData(group)
        // setData(docs) 
    }, [docs, selectedGroup]);

    useLayoutEffect(() => {
        if (chartUnit === 'hours') {
            setRateTypeField('hours_qty')
            setRateTypeFieldReverse('qty_hours')
        } else {
            setRateTypeField('kms_qty')
            setRateTypeFieldReverse('qty_kms')
        }
    }, [chartUnit])

    // useEffect(() => {
    //     console.log(data);
    // }, [data])

    // const changeFieldType = (field = '') => {
    //     setRateTypeField(field)
    //     setRateTypeFieldReverse(field.split('_').reverse().join('_'))
    // }

    useLayoutEffect(() => {
        if (standardFuelRate && standardFuelRate.length) {
            let label = '';
            // console.log(standardFuelRate);

            const hrRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'HOURS'))
            // console.log(hrRate);
            if (hrRate && hrRate[0] && hrRate[0]['fuelQty'])
                setStandardRateHour(hrRate[0]['fuelQty'])

            const kmRate = standardFuelRate.filter(s => (s.perType && s.perType.name && s.perType.name === 'KMS'))
            // console.log(kmRate);
            if (kmRate && kmRate[0] && kmRate[0]['fuelQty'])
                setStandardRateKm(kmRate[0]['fuelQty'])

            // console.log(chartUnit);

            label += `${Number(chartUnit === 'hours' ? Number(hrRate && hrRate[0] && hrRate[0]['fuelQty'] || 0) :
                chartUnit === 'kms' ? Number(kmRate && kmRate[0] && kmRate[0]['fuelQty'] || 0) : 0).toFixed(2)} ${chartUnit}/ltr`;
            label += ` (${Number(1 / (chartUnit === 'hours' ? Number(hrRate && hrRate[0] && hrRate[0]['fuelQty']) || 0 : chartUnit === 'kms' ? Number(kmRate && kmRate[0] && kmRate[0]['fuelQty']) || 0 : 0)).toFixed(2)} ltr./${chartUnit})`;
            // console.log(label);

            setStdLabel(label)
        }
    }, [standardFuelRate, chartUnit, selectedGroup]);

    // useLayoutEffect(() => {
    //     if (assetData) {
    //         setHeader(`Daywise fuel consumption rate chart for asset ${assetData.assetCode}`)
    //     }
    // }, [assetData])

    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} fuel consumption rate chart for ${assetData.assetCode}`)
        }
    }, [selectedGroup, assetData]);

    const chart = useRef(null);


    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalConsumptionRate = 0;
            data.forEach(d => {
                totalConsumptionRate += Number(d[rateTypeField])
            })

            let x = am4core.create("fuelConsumeRate", am4charts.XYChart);
            // am4core.addLicense("ch-custom-attribution");

            let title = x.titles.create();
            title.text = header || '';
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_consumption_rate_time" + new Date().getTime();;

            x.paddingRight = 20;

            let dateAxis = x.xAxes.push(new am4charts.CategoryAxis());
            dateAxis.dataFields.category = "date";
            dateAxis.title.text = selectedGroup === 'm' ? 'Month' : selectedGroup === 'w' ? 'Week' : selectedGroup === 'y' ? 'Year' : 'Date Range';
            // Format the labels
            // dateAxis.renderer.labels.template.adapter.add("text", function (label, target, key) {
            //     console.log(label, target, key);
            //     return label;
            //     // return moment(label).format('MM-DD');
            // });
            // dateAxis.title.text = "Date(DD-MM)"
            // categoryAxis.renderer.minGridDistance = 30;
            // dateAxis.renderer.labels.template.rotation = -90;

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = `Consumption Rate (${transformFiledToLabel(rateTypeField)})`
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = am4core.color("#C61AFC");
            valueAxis.renderer.labels.template.fill = am4core.color("#C61AFC");

            let valueAxis2 = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis2.title.text = `Consumption Rate (${transformFiledToLabel(rateTypeFieldReverse)})`
            // valueAxis2.renderer.opposite = true;
            valueAxis2.renderer.line.strokeOpacity = 1;
            valueAxis2.renderer.line.strokeWidth = 2;
            valueAxis2.renderer.line.stroke = am4core.color("#1AB00B");
            valueAxis2.renderer.labels.template.fill = am4core.color("#1AB00B");

            let valueAxisConsumed = x.yAxes.push(new am4charts.ValueAxis());
            valueAxisConsumed.title.text = `${chartUnit.toUpperCase()} Movement`
            valueAxisConsumed.renderer.opposite = true;
            valueAxisConsumed.renderer.line.strokeOpacity = 1;
            valueAxisConsumed.renderer.line.strokeWidth = 2;
            valueAxisConsumed.renderer.line.stroke = am4core.color("#717d7e");
            valueAxisConsumed.renderer.labels.template.fill = am4core.color("#717d7e");

            // console.log(standardRateKm, standardRateHour, idleFuelRate);

            // if (chartUnit === 'kms' && standardRateKm) {
            //     let averageGuide = valueAxis.axisRanges.create();
            //     averageGuide.value = (1 / standardRateKm).toFixed(2);
            //     averageGuide.grid.stroke = am4core.color("#75f3e0");
            //     averageGuide.grid.strokeWidth = 1.5;
            //     averageGuide.grid.strokeOpacity = 0.7;
            //     averageGuide.grid.strokeDasharray = "4,4";
            //     // averageGuide.label.text = `${(1 / standardRateKm).toFixed(2)}`;
            //     // averageGuide.label.align = "right";
            //     // averageGuide.label.verticalCenter = "bottom";
            // }
            // let label = ``;
            if (standardRateHour || standardRateKm) {
                let averageGuide = valueAxis2.axisRanges.create();
                averageGuide.value = Number(chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0).toFixed(2);
                averageGuide.grid.stroke = am4core.color("#f38875");
                averageGuide.grid.strokeWidth = 1.5;
                averageGuide.grid.strokeOpacity = 0.7;
                averageGuide.grid.strokeDasharray = "4,4";
                // averageGuide.label.align = "right";
                // averageGuide.label.verticalCenter = "bottom";
                // label = +`${Number(chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0).toFixed(2)} ${chartUnit}/ltr`;
                // averageGuide.label.text = `Std. ${Number(chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0).toFixed(2)}`;

                let averageGuideR = valueAxis.axisRanges.create();
                averageGuideR.value = Number(1 / (chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0)).toFixed(2);
                averageGuideR.grid.stroke = am4core.color("#f38875");
                averageGuideR.grid.strokeWidth = 1.5;
                averageGuideR.grid.strokeOpacity = 1;
                averageGuideR.grid.strokeDasharray = "4,4";
                // averageGuideR.label.text = `Std. ${Number(1 / (chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0)).toFixed(2)}`;
                // averageGuideR.label.align = "right";
                // averageGuideR.label.verticalCenter = "bottom";
                // label = +`${Number(1 / (chartUnit === 'hours' ? standardRateHour || 0 : chartUnit === 'kms' ? standardRateKm || 0 : 0)).toFixed(2)} ltr./${chartUnit}`;
            }
            if (idleFuelRate) {
                let averageGuide1 = valueAxis2.axisRanges.create();
                averageGuide1.value = Number(idleFuelRate).toFixed(2);
                averageGuide1.grid.stroke = am4core.color("#444");
                averageGuide1.grid.strokeWidth = 1.5;
                averageGuide1.grid.strokeOpacity = 1;
                averageGuide1.grid.strokeDasharray = "4,4";

                // averageGuide1.label.text = `Idle : ${Number(idleFuelRate).toFixed(2)}`;
                // label = +`${Number(idleFuelRate).toFixed(2)} ${chartUnit}/ltr`;

                let averageGuide1R = valueAxis.axisRanges.create();
                averageGuide1R.value = Number(1 / idleFuelRate).toFixed(2);
                averageGuide1R.grid.stroke = am4core.color("#444");
                averageGuide1R.grid.strokeWidth = 1.5;
                averageGuide1R.grid.strokeOpacity = 1;
                averageGuide1R.grid.strokeDasharray = "4,4";

                // averageGuide1R.label.text = `Idle : ${Number(1 / idleFuelRate).toFixed(2)}`;
                // label = +`${Number(1 / idleFuelRate).toFixed(2)} ltr./${chartUnit}`;
            }

            let lineSeries = x.series.push(new am4charts.LineSeries());
            lineSeries.name = `Rate ${transformFiledToLabel(rateTypeField)}`;
            lineSeries.dataFields.valueY = rateTypeField;
            lineSeries.dataFields.categoryX = "date";
            lineSeries.strokeWidth = 2;
            lineSeries.propertyFields.strokeDasharray = "lineDash";
            lineSeries.tooltip.label.textAlign = "middle";
            lineSeries.yAxis = valueAxis;
            lineSeries.stroke = am4core.color("#C61AFC");

            // lineSeries.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled.toFixed(2)} Kms.)`;
            // console.log(stdLabel);

            // let lineSeriesLabel = x.series.push(new am4charts.LineSeries());
            // lineSeriesLabel.legendSettings.labelText = stdLabel

            let bullet = lineSeries.bullets.push(new am4charts.Bullet());
            bullet.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bullet.tooltipText = "[#C61AFC font-size: 11px]{name} in {dateX}:\n[/][#C61AFC font-size: 15px]{valueY}[/] [#C61AFC]{additional}[/]"
            let circle = bullet.createChild(am4core.Circle);
            circle.radius = 2;
            circle.fill = am4core.color("#fff");
            circle.strokeWidth = 1;

            let lineSeries2 = x.series.push(new am4charts.LineSeries());
            lineSeries2.name = `Rate ${transformFiledToLabel(rateTypeFieldReverse)}`;
            lineSeries2.dataFields.valueY = rateTypeFieldReverse;
            lineSeries2.dataFields.categoryX = "date";

            lineSeries2.stroke = am4core.color("#1AB00B");
            lineSeries2.strokeWidth = 2;
            lineSeries2.propertyFields.strokeDasharray = "lineDash";
            lineSeries2.tooltip.label.textAlign = "middle";
            lineSeries2.yAxis = valueAxis2;
            // lineSeries2.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled_effective.toFixed(2)} Kms.)`;

            let bullet2 = lineSeries2.bullets.push(new am4charts.Bullet());
            bullet2.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bullet2.tooltipText = "[#1AB00B font-size: 11px]{name} in {dateX}:\n[/][#1AB00B font-size: 15px]{valueY}[/] [#1AB00B]{additional}[/]"

            let circle2 = bullet2.createChild(am4core.Circle);
            circle2.radius = 3;
            circle2.fill = am4core.color("#fff");
            circle2.strokeWidth = 1;

            let lineSeriesConsumed = x.series.push(new am4charts.LineSeries());
            lineSeriesConsumed.name = `${chartUnit.toUpperCase()} Consumed`;
            lineSeriesConsumed.dataFields.valueY = chartUnit === 'hours' ? 'hours_consumed' : 'kms_consumed';
            lineSeriesConsumed.dataFields.categoryX = "date";

            lineSeriesConsumed.stroke = am4core.color("#717d7e");
            lineSeriesConsumed.strokeWidth = 1;
            lineSeriesConsumed.propertyFields.strokeDasharray = "lineDash";
            lineSeriesConsumed.tooltip.label.textAlign = "middle";
            lineSeriesConsumed.yAxis = valueAxisConsumed;
            // lineSeriesConsumed.legendSettings.labelText = `Distance. (Total: ${totaldistance_travelled_effective.toFixed(2)} Kms.)`;

            let bulletConsumed = lineSeriesConsumed.bullets.push(new am4charts.Bullet());
            bulletConsumed.fill = am4core.color("#fff"); // tooltips grab fill from parent by default
            bulletConsumed.tooltipText = "[##717d7e font-size: 11px]{name} in {dateX}:\n[/][#717d7e font-size: 15px]{valueY}[/] [#717d7e]{additional}[/]"

            let circleConsumed = bulletConsumed.createChild(am4core.Circle);
            circleConsumed.radius = 3;
            circleConsumed.fill = am4core.color("#fff");
            circleConsumed.strokeWidth = 1;

            let lineSeriesConsumedX = x.series.push(new am4charts.LineSeries());
            lineSeriesConsumedX.dataFields.valueY = chartUnit === 'hours' ? 'hours_consumed' : 'kms_consumed';
            lineSeriesConsumedX.dataFields.categoryX = "date";
            lineSeriesConsumedX.name = `Std. rate : ${stdLabel} ${idleFuelRate ? 'Idle : ' + idleFuelRate.toFixed(2) + ' ltr./hrs.' : ''}`;
            lineSeriesConsumedX.stroke = am4core.color("#717d7e");
            lineSeriesConsumedX.strokeWidth = 1;
            lineSeriesConsumedX.propertyFields.strokeDasharray = "lineDash";
            lineSeriesConsumedX.tooltip.label.textAlign = "middle";
            lineSeriesConsumedX.yAxis = valueAxisConsumed;

            x.legend = new am4charts.Legend();

            // Add cursor
            x.cursor = new am4charts.XYCursor();
            x.cursor.fullWidthLineX = true;
            x.cursor.xAxis = dateAxis;
            x.cursor.lineX.strokeOpacity = 0;
            x.cursor.lineX.fill = am4core.color("#000");
            x.cursor.lineX.fillOpacity = 0.1;

            // Add scrollbar
            if (data && data.length > 25) {
                let scrollbarX = new am4charts.XYChartScrollbar();
                scrollbarX.series.push(lineSeries);
                scrollbarX.series.push(lineSeries2);
                scrollbarX.series.push(lineSeriesConsumed);
                // scrollbarX.marginBottom = 50;
                x.scrollbarX = scrollbarX;
            }

            x.cursor = new am4charts.XYCursor();

            x.data = data;

            chart.current = x;

            return () => {
                if (x)
                    x.dispose();
            };
        }
    }, [data, header, rateTypeField]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return <Card>
        {loading ? (
            <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Loading ...
            </div>
        ) : data && data.length ? (
            <div id="fuelConsumeRate" style={{ width: "100%", height: "500px" }} />
        ) : (
            <div style={{ width: "100%", height: "500px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Empty />
            </div>
        )}
    </Card>
}

export default FuelConsumptionRateChart;